import React from 'react';
import { ExclamationTriangleIcon, FlagIcon } from '@heroicons/react/24/outline';

const AuthorityReviewFlag = ({ 
  reasoning, 
  contradictions,
  className = '',
  variant = 'compact' // 'compact' | 'detailed'
}) => {
  // Check if authority review is required via structured data (preferred) or raw text
  const requiresReview = (
    // Check structured data first (more reliable)
    (contradictions && contradictions.authority_review_required === true) ||
    // Fall back to text parsing
    (reasoning && 
     typeof reasoning === 'string' && 
     /Authority Review Required:\s*YES/i.test(reasoning))
  );


  if (!requiresReview) {
    return null;
  }

  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-center px-2 py-1 bg-red-100 border border-red-300 rounded-md ${className}`}>
        <FlagIcon className="h-4 w-4 text-red-600 mr-1" />
        <span className="text-xs font-medium text-red-800">
          Authority Review Required
        </span>
      </div>
    );
  }

  return (
    <div className={`bg-red-50 border-l-4 border-red-400 p-4 rounded-r-md ${className}`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            🚩 Authority Review Required
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>
              This classification or reasoning requires authoritative review due to rule conflicts,
              ambiguities, or complex security considerations that cannot be automatically resolved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorityReviewFlag;